import keyBy from 'lodash.keyby';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
import { AppState } from 'services/types';
import formatDropdownOptions from 'utils/format-dropdown-options';
import { ProductTypeState } from './types';

const selectProductTypes = (state: AppState): ProductTypeState =>
    state.productTypes;

const selectProductTypeOptions = createDeepEqualSelector(
    selectProductTypes,
    productTypes =>
        formatDropdownOptions(productTypes, {
            keyField: 'id',
            textField: 'name'
        })
);

const selectProductTypesKeyedById = createDeepEqualSelector(
    selectProductTypes,
    productTypes => keyBy(productTypes, 'id')
);

const selectProductTypesParams = createDeepEqualSelector(
    selectCurrentOrganizationId,
    currentOrganizationIdState => ({
        organizationId: currentOrganizationIdState
    })
);

export {
    selectProductTypesParams,
    selectProductTypes,
    selectProductTypeOptions,
    selectProductTypesKeyedById
};
